import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useCallback } from 'react';
import { Text, useDebounce, Button, ButtonVariant, Box } from '@as/cotopaxi';
import { DELAY } from '../../constants/GeneralConstants';
export const TruncatedText = (_a) => {
    var { content, readLessText, readMoreText, lineClamp = 1 } = _a, textProps = __rest(_a, ["content", "readLessText", "readMoreText", "lineClamp"]);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const textRef = useRef();
    const showToggle = isTextTruncated || isExpanded;
    const updateReadMoreBtnState = useCallback(() => {
        if (!textRef.current || isExpanded) {
            return;
        }
        const _isTextTruncated = textRef.current.offsetHeight !== textRef.current.scrollHeight;
        if (_isTextTruncated !== isTextTruncated) {
            setIsTextTruncated(_isTextTruncated);
        }
    }, [textRef, isTextTruncated, isExpanded]);
    const handleResize = useDebounce(updateReadMoreBtnState, DELAY.DELAY_100);
    useEffect(() => {
        updateReadMoreBtnState();
    }, [isTextTruncated, isExpanded]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [updateReadMoreBtnState, handleResize, isExpanded]);
    const textLineClamp = typeof lineClamp === 'number'
        ? lineClamp
        : Object.assign(Object.assign({}, lineClamp), { withGradient: lineClamp.withGradient && isTextTruncated });
    return (_jsxs("div", { children: [_jsx(Text, Object.assign({}, textProps, { innerRef: textRef, lineClamp: isExpanded ? undefined : textLineClamp, children: content })), showToggle && (_jsx(Box, { mobile: { spacing: { marginTop: 2 } }, children: _jsx(Button, { onClick: () => setIsExpanded(prev => !prev), text: isExpanded ? readLessText : readMoreText, variant: ButtonVariant.LINK }) }))] }));
};
